import { Box, Button, Typography } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

// ... existing styles ...

// New styles for the Verify Card
export const CenterHeader = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(3),
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.2rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.5),
}));

export const HeaderSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.9rem',
}));

export const GrayInfoBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#F9FAFB', // Very light grey background
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(3),
  border: `1px solid ${theme.palette.grey[100]}`,
}));

export const ActionButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

export const RejectButton = styled(Button)(({ theme }) => ({
  flex: 1, // Takes up 50% width
  borderColor: theme.palette.success.main, // Using success green for border
  color: theme.palette.success.main,
  textTransform: 'none',
  fontWeight: 600,
  padding: theme.spacing(1.2),
  fontSize: '1rem',
  borderRadius: '8px',
  '&:hover': {
    borderColor: theme.palette.success.dark,
    backgroundColor: alpha(theme.palette.success.main, 0.04),
  },
}));

export const VerifyButton = styled(Button)(({ theme }) => ({
  flex: 1, // Takes up 50% width
  backgroundColor: '#E8F5E9', // Light green background from image
  color: theme.palette.success.dark, // Darker green text
  textTransform: 'none',
  fontWeight: 600,
  padding: theme.spacing(1.2),
  fontSize: '1rem',
  borderRadius: '8px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#C8E6C9',
    boxShadow: 'none',
  },
}));

export const Container = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  // boxShadow: theme.shadows[1], // Optional: Add shadow
}));

export const FieldLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.85rem',
  fontWeight: 600,
  marginBottom: theme.spacing(0.5),
}));

export const FieldValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: 1.5,
}));